
import { Component, Input } from '@angular/core';
import { Check, Edit, LucideAngularModule, X } from 'lucide-angular';
import { FormsModule } from '@angular/forms';
import { ProductVariantModel } from '@app/products/shared/product-variant.model';
import { ProductVariantService } from '@app/products/shared/product-variant.service';

@Component({
  selector: 'app-product-variant-name',
  templateUrl: './product-variant-name.component.html',
  imports: [LucideAngularModule, FormsModule],
  standalone: true
})
export class ProductVariantNameComponent {
  @Input('item') protected variant?: ProductVariantModel;
  protected isEditing = false;
  protected editedName = '';
  protected error: string | undefined;

  constructor(private service: ProductVariantService) {}

  startEdit() {
    console.log(this.variant);
    this.editedName = this.variant?.name || '';
    this.isEditing = true;
  }

  saveEdit() {
    if (this.variant && this.editedName.trim()) {
      this.service.save({
        product_id: this.variant.product_id,
        name: this.editedName.trim()
      } as ProductVariantModel).subscribe({
        next: (response) => {
          if (this.variant) {
            this.variant.name = response.data.name;
          }
          this.isEditing = false;
        },
        error: (error) => {
          this.error = error.error.message;
        }
      });
    }
  }

  cancelEdit() {
    this.isEditing = false;
    this.editedName = '';
  }

  protected readonly Edit = Edit;
  protected readonly Check = Check;
  protected readonly X = X;
}
